export const COUNT_UP = {
  durationToken: '--avyna-wait-spin-cycle',
  fallbackDurationMs: 900,
} as const;
